export const IconSeekerStatusUserComment20: {
  name: 'icon_seeker_status_user_comment_20-60223403a3f4'
} = {
  name: 'icon_seeker_status_user_comment_20-60223403a3f4'
}
